/**
 * 상품 등록일/수정일(BE Instant) 표시 — 목록 '등록일/수정일' 열과 상세 기본 정보 공용.
 *
 * BE updatedAt 은 마이크로초까지 붙을 수 있다(예: `2026-10-01T01:02:03.123456Z`). 소수 초를
 * 3자리로 잘라 Date 가 엔진과 무관하게 같은 값을 읽도록 한 뒤, 관리자 PC 시간대와 상관없이
 * KST "YYYY-MM-DD HH:mm" 로 보여준다.
 */
const KST = new Intl.DateTimeFormat('ko-KR', {
  timeZone: 'Asia/Seoul',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

const FRACTION = /(\.\d{3})\d+/;

export const parseInstant = (iso: string | null | undefined): Date | null => {
  if (!iso) return null;
  const d = new Date(iso.replace(FRACTION, '$1'));
  return Number.isNaN(d.getTime()) ? null : d;
};

/** UTC ISO → KST "YYYY-MM-DD HH:mm". 비었거나 읽을 수 없으면 null. */
export const formatAuditTime = (iso: string | null | undefined): string | null => {
  const d = parseInstant(iso);
  if (!d) return null;
  const parts = KST.formatToParts(d);
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((p) => p.type === type)?.value ?? '';
  return `${part('year')}-${part('month')}-${part('day')} ${part('hour')}:${part('minute')}`;
};

/**
 * 목록 칸용 짧은 표기 — 언제나 KST "YYYY-MM-DD". 비었거나 읽을 수 없으면 null.
 * QA-305: 종전엔 오늘이면 "HH:mm" 만 보여 날짜 칸에 시간이 섞여 보였다. 시각은 칸의 title(전체 표기)로.
 */
export const formatAuditDate = (iso: string | null | undefined): string | null => formatAuditTime(iso)?.slice(0, 10) ?? null;
